var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as componentOverrides from "./overrides";
import { deepmerge } from "@material-ui/utils";
var keyRegex = /create(\w+)Override/;
var getOverrideKey = function (override) {
    var result = keyRegex.exec(override);
    return result && result[1];
};
export var createOverrides = function (theme, options) {
    if (options === void 0) { options = {}; }
    var defaultOverrides = Object.entries(componentOverrides).reduce(function (prev, _a) {
        var _b;
        var key = _a[0], getStyles = _a[1];
        var overrideKey = getOverrideKey(key);
        if (!overrideKey)
            return prev;
        return __assign(__assign({}, prev), (_b = {}, _b[overrideKey] = getStyles(theme), _b));
    }, {});
    var customOverrides = typeof options === "function" ? options(theme) : options;
    return deepmerge(defaultOverrides, customOverrides, { clone: false });
};
//# sourceMappingURL=createOverrides.js.map